<template>
  <div class="drag-content"
       :class="{ threshold: isThreshold }"
       :style="style">
    <slot></slot>
  </div>
</template>

<script>
/**
 * 2.0.0
 * NPM에 등록된 1.2.2 버전 index.js bug로 2.0.0 소스를 임시로 추가하여 사용
 * https://github.com/surmon-china/vue-drag-zone/
 */
export default {
  name: 'drag-content',
  props: {
    fixed: {
      type: [Number, Boolean],
      default: false,
    },
  },
  data() {
    return {
      sizeAttr: null,
      isMinSize: false,
      isMaxSize: false,
    };
  },
  methods: {
    getCss(element, attr) {
      const css = document.defaultView.getComputedStyle(element, null);
      return attr ? css[attr] : css;
    },
    getSize(element) {
      return element.getBoundingClientRect()[this.horizontal ? 'width' : 'height'];
    },
    getSizeAttr(type) {
      return `${type}${this.horizontal ? 'Width' : 'Height'}`;
    },
    getMinSize() {
      let size;
      if (this.fixed) {
        size = this.getSize(this.$el);
      } else {
        let minSize = this.getCss(this.$el, this.getSizeAttr('min'));
        if (minSize === '0px') {
          minSize = 0;
        } else if (minSize.includes('%')) {
          minSize = parseFloat(minSize) / (100 * this.getSize(this.$parent.$el));
        } else if (minSize.includes('px')) {
          minSize = parseFloat(minSize);
        }
        if (minSize < 0) {
          minSize = 0;
        }
        size = minSize;
      }
      return size;
    },
    getMaxSize() {
      let size;
      if (this.fixed) {
        size = this.getSize(this.$el);
      } else {
        let maxSize = this.getCss(this.$el, this.getSizeAttr('max'));
        if (maxSize.includes('%')) {
          maxSize = parseFloat(maxSize) / (100 * this.getSize(this.$parent.$el));
        } else if (maxSize.includes('px')) {
          maxSize = parseFloat(maxSize);
        }
        size = maxSize;
      }
      return size;
    },
  },
  computed: {
    size: {
      get() {
        return this.sizeAttr;
      },
      set(val) {
        this.sizeAttr = val;
      },
    },
    parentOptions() {
      return this.$parent && this.$parent.options && this.$parent.options;
    },
    horizontal() {
      return this.parentOptions.direction === 'horizontal';
    },
    isThreshold() {
      return this.isMinSize || this.isMaxSize;
    },
    style() {
      const style = {};
      if (!this.fixed && this.size !== null && this.parentOptions) {
        if (this.horizontal) {
          style.width = `${this.size}px`;
        } else {
          style.height = `${this.size}px`;
        }
      }
      return style;
    },
  },
};
</script>

<style scoped>
.drag-content {
  /*display: inline-block;*/
}
</style>



// WEBPACK FOOTER //
// src/components/external/VueDragZone/content.vue